import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Consumo } from 'src/app/models/consumo';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-mes-ames-modal',
  templateUrl: './mes-ames-modal.component.html',
  styleUrls: ['./mes-ames-modal.component.scss']
})
export class MesAMesModalComponent implements OnInit, AfterViewInit {

  consumos: Consumo[] = [];
  identificador = 'Consumo 1';
  meses: any[] = [];
  consumoEditando: Consumo;

  editando = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<MesAMesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private utilitarioService: UtilitarioService) {
    this.consumos = data.consumos;

    // if (this.consumos && this.consumos.length > 0) {
    //   this.consumoEditando = this.consumos[0];
    //   this.identificador = this.consumoEditando.identificador;
    //   this.meses = [];
    //   this.consumoEditando.meses.forEach(p => {
    //     this.meses.push({ valor: p.toString().replace('.', ',') });
    //   });
    //   this.editando = true;
    // } else {
    this.identificador = 'Consumo ' + (this.consumos.length + 1);
    this.meses = [];
    for (let i = 0; i < 12; i++) {
      this.meses.push({ valor: '0' });
    }
    //}
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarNomeDoMes(mes) {
    return this.utilitarioService.retornaNomeMes(mes, true);
  }

  fechar() {
    this.dialogRef.close();
  }

  ok() {
    this.dialogRef.close(this.consumos);
  }

  salvar() {
    if (!this.editando) {
      this.consumos.push({ identificador: this.identificador, meses: this.meses.map(p => Number(p.valor)) });
    } else {
      this.consumoEditando.identificador = this.identificador;
      this.consumoEditando.meses = this.meses.map(p => Number(p.valor));
    }

    this.identificador = 'Consumo ' + (this.consumos.length + 1);
    this.meses = [];
    for (let i = 0; i < 12; i++) {
      this.meses.push({ valor: '0' });
    }

    this.editando = false;
  }

  editar(consumo: Consumo) {
    this.consumoEditando = consumo;
    this.identificador = this.consumoEditando.identificador;
    this.meses = [];
    this.consumoEditando.meses.forEach(p => {
      this.meses.push({ valor: p.toString().replace('.', ',') });
    });
    this.editando = true;
  }

  excluir(consumo: Consumo) {
    this.consumos.splice(this.consumos.indexOf(consumo), 1);
  }

}
